import tinyInvariant from "tiny-invariant";

export default function invariant(...args) {
  tinyInvariant(...args);
}
